// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { H1, Link as PockyLink, Text, palette } from '@alto/pocky';
import React from 'react';
import { Link, Link as RRLink } from 'react-router';
import styled from 'styled-components';
import { PHONE } from '~shared/constants';

export const Header = styled(H1)`
  text-align: center;
  color: ${palette.navy};
`;

export const renderHeader = () => <Header>Not Covered by Insurance</Header>;

const renderFooter = () => (
  <Text>
    If you’d like to transfer this prescription to an in-network pharmacy,{' '}
    <RRLink to="/messages">
      <PockyLink>message us</PockyLink>
    </RRLink>{' '}
    and let us know.
  </Text>
);

export const renderFertilityMessage = () => (
  <Text>
    We recommend that you call us at{' '}
    <Link href={`tel:${PHONE}`}>
      <PockyLink>{PHONE}</PockyLink>
    </Link>{' '}
    if you believe you have fertility benefits and this should be covered.
  </Text>
);

export const renderNotCoveredMessage = (insuranceName: string, isFertility: boolean) => (
  <>
    <Text>
      Your insurance ({insuranceName}) won’t cover this prescription because it’s an exclusion from your plan.
    </Text>
    {isFertility ? renderFertilityMessage() : null}
  </>
);

export const renderAltOutOfNetworkMessage = (insuranceName: string) => {
  return (
    <>
      <Text>
        Your insurance ({insuranceName}) rejected this prescription because Alto is considered an out-of-network
        pharmacy.
      </Text>
      {renderFooter()}
    </>
  );
};

export const renderAltOutOfNetworkProductMessage = (insuranceName: string) => (
  <>
    <Text>
      Your insurance ({insuranceName}) rejected this prescription because Alto is considered out-of-network for this
      specific medication or product.
    </Text>
    {renderFooter()}
  </>
);

export const renderPriorAuthRequiredMessage = (insuranceName: string) => (
  <>
    <Text>
      Your insurance ({insuranceName}) won’t cover this prescription because it’s an exclusion from your plan.
    </Text>
    <Text>
      <Text
        bold
        inline
      >
        We recommend asking your prescriber about appealing to obtain coverage or alternatives.
      </Text>{' '}
      For your prescriptions, either your insurance or your doctor has asked Alto not to submit prior authorizations for
      you.
    </Text>
  </>
);
